/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface IdentityParams { 
    /**
     * The create identity transaction signed with the subject private key. This transaction must contain the subject public key to store it on the blockchain. Encoded in Base64 format
     */
    signedCreateIdentityTransaction: IdentityParams.SignedCreateIdentityTransactionEnum;
    /**
     * The create identity transaction signed with the subject private key. This transaction must contain the subject public key to store it on the blockchain. Encoded in Base64 format
     */
    subjectPublicKey: IdentityParams.SubjectPublicKeyEnum;
}
export namespace IdentityParams {
    export const SignedCreateIdentityTransactionEnum = {
        B4339e0de: '[B@4339e0de'
    } as const;
    export type SignedCreateIdentityTransactionEnum = typeof SignedCreateIdentityTransactionEnum[keyof typeof SignedCreateIdentityTransactionEnum];
    export const SubjectPublicKeyEnum = {
        B153cd6bb: '[B@153cd6bb'
    } as const;
    export type SubjectPublicKeyEnum = typeof SubjectPublicKeyEnum[keyof typeof SubjectPublicKeyEnum];
}


